// import { createContext, useState } from "react";

// const [selectedPeriod, setSelectedPeriod] = useState(undefined);

// const FootballStatsContext = createContext({
//   selectedPeriod,
//   setSelectedPeriod,
// });

// const FootballStatsContextProvider = ({ children }) => {
//   return (
//     <FootballStatsContext.Provider
//       value={{ selectedPeriod, setSelectedPeriod }}
//     >
//       {children}
//     </FootballStatsContext.Provider>
//   );
// };

// export { FootballStatsContext, FootballStatsContextProvider };

import React, { createContext, useContext, useReducer } from "react";

const reducer = (state, action = {}) => {
  return {
    ...state,
    ...action,
  };
};

export const CricketStatsContext = createContext();

export const CricketStatsContextProvider = ({ children, initialState }) => (
  <CricketStatsContext.Provider value={useReducer(reducer, initialState)}>
    {children}
  </CricketStatsContext.Provider>
);

export const useCricketScoringState = () => useContext(CricketStatsContext);
